<template>
  <div class="h-screen max-h-screen overflow-hidden">
    <div class="h-dvh transition-all duration-150 relative flex items-center justify-center overflow-hidden">
      <TheNav />
      <div class="flex absolute inset-0 items-center justify-center">
        <img
          ref="heroImage"
          src="../assets/imgs/hero-magazine.png"
          class="hero-image transition-transform duration-2000 z-[999]"
          alt="hero magazine"
        />
      </div>
      <div class="overflow-hidden flex justify-center -mt-[40vh]">
        <img
          ref="startLogo"
          src="../assets/imgs/blackout-logo.svg"
          class="start-logo transition-transform duration-2000"
          alt="blackout logo"
        />
      </div>
      <div
        class="absolute md:bottom-0 left-0 right-0 w-full px-5 md:px-24 bottom-10 md:h-36 flex md:items-center md:gap-0 gap-4 justify-between md:flex-row flex-col-reverse"
      >
        <img
          class="md:w-auto w-1/2"
          src="../assets/imgs/hero-footer-logo.svg"
          alt="hero footer logo"
        />
        <div
          class="font-primary font-medium md:text-3xl text-xl uppercase text-white md:text-right"
        >
          Mehr als nur <br />
          schwarz und weiss
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from "vue";
import TheNav from "./TheNav.vue";

const startLogo = ref(null);
const heroImage = ref(null);

const disableScroll = () => {
  document.body.classList.add('no-scroll');
};

const enableScroll = () => {
  document.body.classList.remove('no-scroll');
};

onMounted(() => {
  // Ensure the page scrolls to the top and disable scrolling
  disableScroll();

  nextTick(() => {
    setTimeout(() => {
      if (startLogo.value) {
        startLogo.value.style.transform = "translateY(120%)";
      }
      if (heroImage.value) {
        heroImage.value.style.transform = "translateY(0%) rotate(0deg)";
      }

      // Re-enable scrolling after animation is complete
      setTimeout(() => {
        enableScroll();
      }, 2300); // Match this duration with your animation duration
    }, 2000);
  });
});
</script>

<style>
.start-logo {
  width: 90vw;
  transition-timing-function: cubic-bezier(.4,.17,.36,.87);
  transition-duration: 2000ms;
}
.hero-image {
  transition-timing-function: cubic-bezier(.4,.17,.36,.87);
  transform: translateY(125vh) rotate(25deg); /* Initial position off-screen with rotation */
  position: relative; /* Ensure it's positioned relative to the container */
  max-width: 100%;
  height: auto;
  transition-duration: 2000ms;
}

/* Utility class to disable scrolling */
.no-scroll {
  overflow: hidden;
  height: 100%;
  position: fixed;
  width: 100%;
  top: 0;
}
</style>